import Link from 'next/link';
import { useContext } from 'react';
import { ThinArrowIcon } from 'src/components/shared/elements/icons/ThinArrowIcon';
import { getLargeCategoryIcon } from 'src/components/shared/templates/header/HamburgerMenu/index';
import { KaimonoWebRoutes } from 'src/config/routes';
import { CategoryContext } from 'src/stores/Category';
import { I18nContext } from 'src/stores/I18n';
import { mapMiddleToSmallCategories } from 'src/utils/categoryMap';

export const CategoryListForPc = ({
  isPcCategoryMenuOpen,
  togglePcCategoryMenu
}: {
  isPcCategoryMenuOpen: boolean;
  togglePcCategoryMenu: () => void;
}) => {
  const categories = useContext(CategoryContext);
  const localeResources = useContext(I18nContext);
  const middleCategories = mapMiddleToSmallCategories(categories);
  if (!categories) return null;

  return (
    <>
      {isPcCategoryMenuOpen ? (
        <ul className="flex flex-col">
          {categories.largeCategories.map((largeCategory) => (
            <li
              key={largeCategory.largeCategoryId}
              className="group flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray100"
            >
              <span className="w-6 grid place-content-center">
                {getLargeCategoryIcon(
                  largeCategory.slug,
                  largeCategory.slug === 'living_travel' ? 'w-6 h-6' : 'w-5 h-5'
                )}
              </span>
              <span>{largeCategory.name}</span>
              <div
                className="hidden group-hover:flex fixed left-[290px] top-[60px] w-[calc(100%-290px)] h-[calc(100vh-60px)] bg-gray900 text-white pt-12 px-4 overflow-scroll"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="max-w-[650px] w-full whitespace-nowrap">
                  <div className="border-solid border-b-2 border-white">
                    <div className="px-5 pb-4">
                      <Link href={KaimonoWebRoutes.largeCategories.show(largeCategory.slug)}>
                        <a className="hover:underline">{largeCategory.name}</a>
                      </Link>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 w-full gap-x-3 gap-y-5 px-5 py-9">
                    {middleCategories
                      ?.filter((mc) => largeCategory.middleCategoryIds.includes(mc.middleCategoryId))
                      .map((middleCategory) => {
                        const smallCategories = middleCategory.smallCategories.map(({ smallCategoryId, slug }) => (
                          <Link href={KaimonoWebRoutes.smallCategories.show(slug)} key={slug}>
                            <a className="hover:underline">
                              {categories.smallCategories.find((sc) => sc.smallCategoryId === smallCategoryId)?.name}
                            </a>
                          </Link>
                        ));
                        return (
                          <div className="text-xs font-medium" key={middleCategory.middleCategoryId}>
                            <Link href={KaimonoWebRoutes.middleCategories.show(middleCategory.slug)}>
                              <a className="hover:underline">{middleCategory.name}</a>
                            </Link>
                            <div className="flex flex-wrap gap-x-3 gap-y-2 pt-3 px-5">{smallCategories}</div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="px-4 py-2 flex items-center cursor-pointer hover:bg-gray100" onClick={togglePcCategoryMenu}>
          <span>{localeResources.category.title}</span>
          <ThinArrowIcon className="w-4 h-4 ml-auto" direction="right" />
        </div>
      )}
    </>
  );
};
